import { render, staticRenderFns } from "./EmergingArtworkCardInfo.vue?vue&type=template&id=963b91f6&scoped=true&"
import script from "./EmergingArtworkCardInfo.vue?vue&type=script&lang=js&"
export * from "./EmergingArtworkCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmergingArtworkCardInfo.vue?vue&type=style&index=0&id=963b91f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963b91f6",
  null
  
)

export default component.exports